var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 0.916795C9.66667 0.686676 9.48012 0.500128 9.25 0.500128H7.16667C4.98276 0.39134 3.12106 2.06687 3 4.25013V6.50013H0.916667C0.686548 6.50013 0.5 6.68668 0.5 6.9168V9.08346C0.5 9.31358 0.686548 9.50013 0.916667 9.50013H3V15.0835C3 15.3136 3.18655 15.5001 3.41667 15.5001H5.91667C6.14679 15.5001 6.33333 15.3136 6.33333 15.0835V9.50013H8.51667C8.70729 9.50287 8.87545 9.37588 8.925 9.19179L9.525 7.02513C9.5586 6.90035 9.53241 6.76705 9.4541 6.66427C9.37578 6.56149 9.25422 6.50085 9.125 6.50013H6.33333V4.25013C6.37629 3.82271 6.7371 3.49798 7.16667 3.50013H9.25C9.48012 3.50013 9.66667 3.31358 9.66667 3.08346V0.916795Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.85675f4ec0f6c22f82fbb9385672895d.svg";
export { ForwardRef as ReactComponent };